import {
    HorizAlignment,
    ISearch,
    ISearchProfile,
    ISearchProvider,
    ISearchProviderField,
    ISearchRequestSubset, ITree,
    SearchProviderFieldType
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"
import {SearchUtils} from "../PA.UIM.Core/SearchUtils";
import {PASearch} from "../PA.Core/PASearch";
import {PAEnvironment} from "../PA.Core/PAEnvironment";
import {ColumnNodeProvider} from "../PA.UIM.Core/SearchTreeUtils";

const vUI_Batch_Process_Search_Fields: {[id: string]: ISearchProviderField}  = {
    WB_BATCHPROCESS_ID:     {type: SearchProviderFieldType.number,   renderOptions: { columnName: 'Wb Id',     columnResourceName: 'colwbId',      alignment: HorizAlignment.Left},  domainOptions: {} },
    BATCHPROCESS_ID:    {type: SearchProviderFieldType.string,   renderOptions: { columnName: 'ID',        columnResourceName: 'colId',        alignment: HorizAlignment.Left},  domainOptions: {maxLength: 50}},
    BATCHPROCESS_NAME:  {type: SearchProviderFieldType.string,   renderOptions: { columnName: 'Batch Process Template',      columnResourceName: 'colName',      alignment: HorizAlignment.Left},  domainOptions: {maxLength: 256}},
    WB_BATCHSCOPE_ID:        {type: SearchProviderFieldType.number,   renderOptions: { columnName: 'Scope Wb Id',     columnResourceName: 'colwbScopeId',      alignment: HorizAlignment.Left},  domainOptions: {} },
    BATCH_SCOPE:              {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Enterprise Scope',   columnResourceName: 'colScope',   alignment: HorizAlignment.Left},  domainOptions: {maxLength: 256}},
    JOB_ID:         {type: SearchProviderFieldType.string,   renderOptions: { columnName: 'External Process', columnResourceName: 'colExternalProcess', alignment: HorizAlignment.Left},  domainOptions: {maxLength: 50}},
    CREATED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Created Date',
            columnResourceName: 'colCreateDt',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    },
    MODIFIED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Modified Date',
            columnResourceName: 'colModifiedDt',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    }
};

const BatchProcessSearchProviderBasic: ISearchProvider = {

    keyFields: {id:    'WB_BATCHPROCESS_ID',
        id_ui: 'BATCHPROCESS_ID',
        name:  'BATCHPROCESS_NAME'

    },

    searchProviderFields: vUI_Batch_Process_Search_Fields,

    search(searchRequestSubset: ISearchRequestSubset): Promise<any[]> {
        return new Promise<any[]>((resolve, error)=>{
            let findRequest = SearchUtils.makeSearchRequest(searchRequestSubset,
                'vUI_Batch_Process_Search',
                this.searchProviderFields,
                []);

            PASearch.findByRequest(findRequest)
                .then((res: any[])=> {
                    resolve(res)
                })
                .catch((err)=> {
                    error(err)
                });
        })
    }
};

const BatchProcessSearchProfileByName: ISearchProfile = {
    profileId: "default",
    profileName: "Search by Name",
    renderOptions: {ui5SourceId: "BatchProcessSearchProfileByName"},

    profileFilter: [
        {profileFilterName: 'Name', searchProviderFieldId: 'BATCHPROCESS_NAME', renderOptions: {}}
    ], //ISearchFields
    profileDisplayFields: [
        'BATCHPROCESS_ID', 'BATCHPROCESS_NAME','BATCH_SCOPE','JOB_ID',  'CREATED_DTTS', 'MODIFIED_DTTS'
    ],

    profileSearchProvider: BatchProcessSearchProviderBasic,

    profileTreeIdDefault: "default",
    profileTrees: [
        {treeId: "default",
            treeName: "By Hierarchy",
            nodeProviders: [ new ColumnNodeProvider(['TREE_PATH'], {defaultValues: "No Parent Set"})],
            renderOptions: {}}
    ],

    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];
};

const BatchProcessSearch: ISearch = {
    searchName: "Find Batch Process",
    renderOptions: {ui5ResourceId: "BatchProcessSearch"},
    searchProfileIdDefault: "default",
    searchProfiles: [BatchProcessSearchProfileByName]
};

PAEnvironment.registerBusinessObjectSearch("BatchProcessBO", "BatchProcess", BatchProcessSearch, "Batch Process Search")

export {BatchProcessSearch}